module.exports = __webpack_public_path__ + "img/goal-06.90f278f3.png";